import { InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { OfflineDocumentsList } from "./OfflineDocumentsList";

const Root = styled("div")(({ theme }) => ({}));

export interface DocumentsProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

export const OfflineDocuments = (props: DocumentsProps) => {
    const { className, ...rest } = props;
    const navigate = useNavigate();
    const { linkProvider } = useRouting();

    const onBackClick = () => {
        navigate(linkProvider.react.offline().index());
    };

    return (
        <Root {...rest} className={className}>
            <AppHeader
                title={"Documents"}
                canGoBack
                searchable={false}
                onBackClick={onBackClick}
            />
            <OfflineDocumentsList />
        </Root>
    );
};
